import { render } from "./Lotes.vue?vue&type=template&id=57c85f8c&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"empresas\":\"data\",\"obtenerEmpresas\":\"options\"}"
import script from "./Lotes.vue?vue&type=script&lang=js"
export * from "./Lotes.vue?vue&type=script&lang=js"
script.render = render

export default script